var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDocument = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 10.5h4v1h-4v-1zm5-2h-5v1h5v-1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4 1.25A1.75 1.75 0 0 0 2.25 3v10c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 13.75 13V6.414c0-.464-.184-.909-.513-1.237L9.823 1.763a1.75 1.75 0 0 0-1.237-.513H4zM3.75 3A.25.25 0 0 1 4 2.75h4.5V6.5h3.75V13a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V3zm7.69 2.5L9.5 3.56V5.5h1.94z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export default ForwardRef;